import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AntageneFileItem, AntageneUploadService } from '../../../services/antagene-upload.service';

@Component({
  selector: 'app-fichiers-en-attente-analyse-taches',
  imports: [CommonModule, RouterLink],
  templateUrl: './fichiers-en-attente-analyse-taches.component.html',
  styleUrl: './fichiers-en-attente-analyse-taches.component.scss'
})
export class FichiersEnAttenteAnalyseTachesComponent implements OnInit {
  protected loading = false;
  protected error = '';
  protected items: AntageneFileItem[] = [];

  constructor(
    private readonly antageneUploadService: AntageneUploadService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.load();
  }

  protected refresh(): void {
    this.load();
  }

  protected formatDate(dateString: string | null | undefined): string {
    if (!dateString) {
      return '';
    }
    try {
      return new Date(dateString).toLocaleString('fr-FR');
    } catch {
      return dateString;
    }
  }

  private load(): void {
    this.loading = true;
    this.error = '';
    this.cdr.markForCheck();

    this.antageneUploadService.listFilesSansAnalyse().subscribe({
      next: (response) => {
        this.items = response.items ?? [];
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: (err: HttpErrorResponse) => {
        this.items = [];
        this.error = this.getErrorMessage(err);
        this.loading = false;
        this.cdr.markForCheck();
      }
    });
  }

  private getErrorMessage(err: HttpErrorResponse): string {
    if (typeof err.error === 'string' && err.error.trim()) {
      return err.error;
    }
    if (err.error?.detail) {
      return String(err.error.detail);
    }
    if (err.error?.message) {
      return String(err.error.message);
    }
    return err.statusText || 'Erreur inconnue';
  }
}